import { render, staticRenderFns } from "./MailNotifyGroupFilter.vue?vue&type=template&id=5ed8b955&"
import script from "./MailNotifyGroupFilter.vue?vue&type=script&lang=ts&"
export * from "./MailNotifyGroupFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports